<h3 mat-dialog-title class="title primary">
</h3>
<div mat-dialog-content>
    <div class="wrapper">
        <div class="col-12 head">
            <div>
                {{titolo | translate | uppercase}}
            </div>
        </div>
        <div class="col-12" [innerHTML]="messaggio | translate">

        </div>
        <div class="col-12">
            <button class="btn" (click)="ok()" *ngIf="confermaAzione">
                {{testoOk | translate}}
            </button>
            <button class="btn" (click)="cancel()" *ngIf="visualizzaCancel">
                {{testoCancel | translate}}
            </button>
        </div>
    </div>
</div>